var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stage round-robin__stage"},[(!_vm.tournament.getRR().rooms.length)?_c('CreateRooms'):_vm._e(),(_vm.tournament.getRR().rooms.length > 0 && !_vm.tournament.getRR().is_generated_rooms)?_c('ControlsRooms'):_vm._e(),(_vm.tournament.getRR().is_generated_rooms)?_c('RoomsMatchesArea'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }